import 'blueimp-file-upload'
import 'canvas-to-blob'
import 'blueimp-load-image'
import 'blueimp-file-upload/js/jquery.fileupload-image'
import 'blueimp-file-upload/js/jquery.fileupload-audio'
import 'blueimp-file-upload/js/jquery.fileupload-video'
import tmpl from 'blueimp-tmpl/js/tmpl'

window.tmpl = tmpl
import 'blueimp-file-upload'
import 'canvas-to-blob'
import 'blueimp-load-image'
import 'blueimp-file-upload/js/jquery.fileupload-image'
import 'blueimp-file-upload/js/jquery.fileupload-audio'
import 'blueimp-file-upload/js/jquery.fileupload-video'
import tmpl from 'blueimp-tmpl/js/tmpl'

window.tmpl = tmpl
